var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLevel7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e2711c;}.b{fill:none;stroke:#003c71;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1080 -524)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42,0A42,42,0,1,1,0,42,42,42,0,0,1,42,0Z",
    transform: "translate(1080 524)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(709.46 529.122)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 12.929,
    y2: 1.728,
    transform: "translate(394.134 28.722)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 12.929,
    y2: 1.728,
    transform: "translate(417.808 28.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M430.4,54.8c-3.382-5.256-8.348-9.169-18.645-9.169s-16.13,4.585-18.644,9.169"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel7);
export default __webpack_public_path__ + "static/media/level7.9085760be89ef65fe3260be586749846.svg";
export { ForwardRef as ReactComponent };